import React from "react";
import MediaQuery from "react-responsive";
import queryStringParser from "query-string";
import Welcome from "./page/Welcome";
import LandscapeApp from "./landscape/App";
import PortraitApp from "./portrait/App";
import config from "./config/config.json";
import stringData from "./assets/strings.json";
import CookieConsent, { Cookies } from "react-cookie-consent";
import { Link } from "react-router-dom";
import { useMatomo } from "@datapunt/matomo-tracker-react";

const App = function (props) {
  let id = localStorage.getItem("id");
  if (id == null) {
    id = config.companies[0].value;
    localStorage.setItem("id", id);
  }

  /*
   * Language state is kept in localStorage.
   * When not specified, it defaults to the first language in the config object.
   */
  let lang = localStorage.getItem("lang");
  if (lang == null) {
    lang = config.languages[0];
    localStorage.setItem("lang", lang);
  }

  /*
   * Check if the optional GET parameter 'lang' was passed with a valid option.
   * If so, then set the language accordingly.
   */
  let queryParams = queryStringParser.parse(props.location.search);
  const compExists = config.companies.findIndex((obj) => {
    return obj.value === queryParams["id"];
  });
  if (Object.keys(queryParams).includes("id") && compExists !== -1) {
    id = queryParams["id"];
    localStorage.setItem("id", id);
  }

  if (
    Object.keys(queryParams).includes("lang") &&
    config.languages.includes(queryParams["lang"])
  ) {
    lang = queryParams["lang"];
    localStorage.setItem("lang", lang);
  }

  const [langState, setLang] = React.useState(lang);
  const [acceptedCookiesState, setAcceptedCookies] = React.useState(
    !!Cookies.get("CookieConsent")
  );
  const [idState, setId] = React.useState(id);

  const { trackPageView } = useMatomo();

  React.useEffect(() => {
    if (process.env.REACT_APP_ENV === "prod" && acceptedCookiesState) {
      trackPageView();
    }
  }, [acceptedCookiesState]);

  React.useEffect(() => {
    /* TODO
     * The isFirstTime state change doesn't map to a new render, that's why we keep it away from
     * this.state . However, there has to be a better/cleaner way of doing this.
     */
    localStorage.setItem("isFirstTime", "false");
  }, []);

  function goCookies() {
    window.location.href =
      config["front-end-server"]["url-prefix"] +
      props.match.params.hash +
      "/cookies";
  }

  let isFirstTime = localStorage.getItem("isFirstTime");
  isFirstTime = isFirstTime === null;
  const message = stringData[langState].web.cookies.policy;
  const linkText = stringData[langState].web.cookies["know-more"];
  const idx = config.companies.findIndex((obj) => {
    return obj.value === id;
  });
  const company = config.companies[idx].title;

  return (
    <div className={company}>
      {isFirstTime ? <Welcome logo={company} /> : null}
      <MediaQuery orientation="portrait">
        <PortraitApp {...props} lang={langState} logo={company} />
      </MediaQuery>
      <MediaQuery orientation="landscape">
        <LandscapeApp {...props} lang={langState} logo={company} />
      </MediaQuery>
      <CookieConsent
        buttonText="Okay"
        style={{ justifyContent: "flex-end", textAlign: "center" }}
        buttonStyle={{ backgroundColor: "#F5922A", borderRadius: "3px" }}
      >
        {message}
        <Link
          to={
            config["front-end-server"]["url-prefix"] +
            props.match.params.hash +
            "/cookies"
          }
          className="cookie-know-more"
        >
          {linkText}
        </Link>
      </CookieConsent>
    </div>
  );
};

export default App;
